import { useRef } from 'react';
import cm from 'classnames';

import { Rotate } from 'services/file.service';
import { useCssRotate } from 'components/app/_mediator/css-rotate/use-css-rotate';

import { ReactComponent as RotateIcon } from 'assets/wavesurfer/reset.svg';
import styles from '../_editor-config.module.scss';

interface Props {
  disable?: boolean;
  rotate: Rotate | null;
  onClick: () => void;
}

export const ConfigRotate = ({ disable, rotate, onClick }: Props) => {
  const ref = useRef(null);
  useCssRotate(ref, { rotate });

  return (
    <div
      className={cm(styles.Config__rotate, { [styles['Config__rotate--disable']]: disable })}
      onClick={() => !disable && onClick()}
    >
      <div ref={ref}>
        <RotateIcon className={cm({ [styles['Config__rotate--active']]: rotate !== null })} />
      </div>
      <span>Rotate{rotate !== null && ` (${rotate === Rotate.default ? 360 : rotate * 90}°)`}</span>
    </div>
  );
};
